<template>
  <div class="Field__Component">
    <div class="icon" v-if="item">
      <b-button @click.stop="preview(item)">
        <b-icon icon="eye" />
      </b-button>
    </div>
  </div>
</template>

<script>
import DialogMunicipalityProviders from "@/components/DialogMunicipalityProviders.vue";

export default {
  name: "FieldProvidersByMunicipalityId",
  props: ["value", "item"],
  methods: {
    preview(value) {
      this.$buefy.modal.open({
        component: DialogMunicipalityProviders,
        props: {
          municipality: value,
        },
        width: 1400,
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.Field__Component {
  width: 100%;
  text-align: center;

  ::v-deep button {
    border: none;
    background: transparent;

    &:focus,
    &:active {
      box-shadow: none;
    }
  }

  .icon {
    transition: transform 0.1s linear;
    cursor: pointer;

    &:active {
      transform: scale(0.98);
    }
  }
}
</style>
